// extracted by css-extract-rspack-plugin
export default {"dashboard":"dashboard-xWV3bQ"};